
export const UsersGroupsFields = [
    { display: 'GroupCode', required: true, code: 'Code', type: 'text', translate: true },
    { display: 'GroupName', required: false, code: 'Name', type: 'text', translate: true },
]

export const ConditionsFields = [
    { display: 'Condition', translate: true, required: false, code: 'condition', type: 'select', options: 'conditionOptions', extraField: 'conditionValue' },
    { display: 'Operation', translate: true, required: false, code: 'operation', type: 'select', options: 'operationOptions', extraField: 'operationValue' },
    { display: 'Value', translate: true, required: false, code: 'value', type: 'number' },
    { display: 'Group', translate: true, required: false, code: 'group', type: 'select', options: '', extraField: 'groupValue' },
    { type: 'whitespace' },
]

export const SystemsTablesOptions = [
    { label: 'Booking', value: 'Booking' },
    { label: 'BL', value: 'BL' },
    { label: 'Account', value: 'Account' },
    { label: 'Quote', value: 'Quote' },
]

export const operandOptions = [
    { label: 'AND', value: 'AND' },
    { label: 'OR', value: 'OR' },
]

export const operationOptions = [
    { label: 'Equals', value: 'E' },
    { label: 'NotEquals', value: 'N' },
    // { label: 'Greater', value: 'greater' },
    // { label: 'Smaller', value: 'smaller' },
]

export const statusOptions = [
    { label: 'Approved', value: 'Approved' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Waiting for Approval', value: 'WatingForApproval' },
    { label: 'Waiting for Approval (Changes)', value: 'WatingForApprovalChanges' },
    { label: 'Waiting for Approval (Cancel)', value: 'WaitingForApprovalCancel' },
    { label: 'Draft', value: 'Draft' },
]

export const groupFieldOptions = [
    { label: 'New', value: 'new' },
]





